<template>
  <div>
    <v-select
      v-model="destinazione"
      :items="items"
      :label="item.label"
      :rules="rulesValidation"
      item-text="descrizione"
      item-value="codice"
      :hint="hintDestinazione"
      persistent-hint      
      clearable
      :return-object="true"
      :disabled="disabled || localDisabled"
      @change="onchange"
    >
      <template v-slot:prepend>
        <v-icon v-if="!item.addForbidden && destinazione" color="info" @click="onModificaDestinazione" title="Modifica destinazione">mdi-pencil</v-icon>        
      </template>
      <template v-slot:append-outer>  
        <v-icon v-if="!item.addForbidden" color="success" @click="onNuovaDestinazione" title="Crea una nuova destinazione">mdi-map-marker-outline</v-icon>
      </template>
    </v-select>
    <div v-if="modificaDestinazione" class="blue lighten-5">
      <v-select
        v-model="editedItem.tipo"
        label="Tipo"
        :items="tipiDestinazione"
        item-text="descrizione"
        item-value="codice"
        clearable
        :return-object="true"
        :disabled="editedItem.tipo.codice === 'principale'"
      />
      <v-text-field v-model="editedItem.indirizzo" label="Indirizzo"></v-text-field>
      <v-autocomplete
        v-model="editedItem.localitaCompleta"
        label="Località"
        :items="localita"
        item-text="descrizione"
        item-value="codice"
        :hint="editedItem && editedItem.localitaCompleta && editedItem.localitaCompleta.hint"
        persistent-hint
        clearable
        :return-object="true"
      >
      </v-autocomplete>
      <v-text-field v-model="editedItem.telefono" label="Telefono" clearable></v-text-field>
      <v-text-field v-model="editedItem.email" label="Email" :rules="rulesEmail" clearable></v-text-field>
      <div class="text-right"><v-btn class="ma-2" :loading="saving" :disabled="saving" color="info" @click="onSalva">Salva modifiche</v-btn></div>
    </div>
    <div v-if="nuovaDestinazione" class="green lighten-5">
      <v-select
        v-model="editedItem.tipo"
        label="Tipo"
        :items="tipiDestinazioneAmmessi"
        item-text="descrizione"
        item-value="codice"
        clearable
        :return-object="true"
        :disabled="editedItem.tipo.codice === 'principale'"
      />
      <v-text-field v-model="editedItem.indirizzo" label="Indirizzo"></v-text-field>
      <v-autocomplete
        v-model="editedItem.localitaCompleta"
        label="Località"
        :items="localita"
        item-text="descrizione"
        item-value="codice"
        :hint="editedItem && editedItem.localitaCompleta && editedItem.localitaCompleta.hint"
        persistent-hint
        clearable
        :return-object="true"
      />
      <v-text-field v-model="editedItem.telefono" label="Telefono" clearable></v-text-field>
      <v-text-field v-model="editedItem.email" label="Email" :rules="rulesEmail" clearable></v-text-field>
      <div class="text-right"><v-btn class="ma-2" :loading="saving" :disabled="saving" color="success" @click="onSalva">Salva nuova</v-btn></div>
    </div>  
  </div>
</template>

<script>
  import _ from 'lodash'
  import { validazioni } from '@/mixins/validazioni.js'
  import clienti from '@/services/clientiService.js'
  import tabelle from '@/services/tabelleService.js'
  import configurazioni from '@/services/configurazioniService.js'
  import { v4 as uuidv4 } from 'uuid'

  export default {
    name: 'destinazione',
    mixins: [
      validazioni
    ],
    props: {
      item: Object,
      appoggio: Object,
      disabled: { type: Boolean, default: false },
      updateTrigger: Number
    },
    data (vm) {
      return {
      loading: false,
      saving: false,
      items: [],
      localita: [],
      destinazione: '',
      selectFirst: true,
      newItem: null,
      cliforId: '',
      clifor: null,
      // province: [],
      tipiDestinazione: [],
      editedItem: null,
      editedItemDefault: {
        tipo: '',
        indirizzo: '',
        localita: '',
        cap:  '',
        provincia:  '',
        nomeProvincia:  '',
        nazione:  '',
        nomeNazione:  '',
        telefono: '',
        email: ''
      },
      modificaDestinazione: false,
      nuovaDestinazione: false
      }
    },
    async created() {
      const elenco = await tabelle.getTabella('anagrafica_localita', 'localita')
      this.localita = elenco.map(x => {
        return {
          codice: `${x.cap}-${x.localita}-${x.nomeProvincia}`,
          descrizione: `${x.cap} ${x.localita}`,
          hint: `${x.nomeProvincia} (${x.provincia})`,
          localita: x.localita,
          provincia: x.provincia,
          nomeProvincia: x.nomeProvincia,
          cap: x.cap,
          nazione: 'IT',
          nomeNazione: 'Italia'
        }
      })
    },
    async mounted() {
      if (this.item && this.item.value) {
        const codice = this.item.value.codice
        await this.leggeRecapiti()
        this.destinazione = Object.assign({}, this.items[0])
      }
      // this.province = await tabelle.getTabella('anagrafica_province', 'province')
      this.tipiDestinazione = await configurazioni.getConfigurazione('documenti_parametri', 'tipiDestinazione')
    },
    watch: {
      async cliforSelezionato(val) {
        await this.leggeRecapiti(val)
        this.destinazione = this.items[0]
      }
    },
    computed: {
      rulesEmail() { // TODO: prendere da DB su elemento ?
        let rl = []
        rl.push(this.rules.email)
        return rl
      },
      localDisabled() {
        if (!this.item || !this.appoggio) {
          return true
        }
        return !(this.appoggio.tipoDocumento && this.appoggio.tipoDocumento.infoSpedizione)
      },
      cliforSelezionato() {
        return this.updateTrigger && this.appoggio && this.appoggio.clifor
      },
      tipiDestinazioneAmmessi() {
        return this.tipiDestinazione.filter(x => !x.default)
      },
      hintDestinazione() {
        if (!this.destinazione || !this.clifor) return ''
        const dest = this.clifor.recapiti[this.destinazione.id]
        return `${dest.cap} - ${dest.localita} (${dest.provincia})` 
      }
    },
    methods: {
      async leggeRecapiti (cliforSelezionato) {
        var clifor
        if (cliforSelezionato) {
          clifor = cliforSelezionato
        } else {
          let clienteId = this.cliforSelezionato && this.cliforSelezionato.codice
          if (!clienteId) return
          clifor = await clienti.getCliente(clienteId)
        }

        if (clifor.recapiti.length === 0) {
          let newInd = this.editedItemDefault
          newInd.tipo = { codice: 'principale', descrizione: 'Sede' }
          newInd.codice = uuidv4()
          clifor.recapiti.push(newInd)
        }
        this.clifor = clifor
        this.items = clifor.recapiti.map((x, idx) => {
          return {
            codice: x.codice || uuidv4(),
            descrizione: `${x.tipo.descrizione}: ${x.indirizzo}`,
            id: idx,
            ...x
          }
        })
      },
      onchange(value) {
        if (value) {
/*           debugger
          const destinazione = {
            codice: this.destinazione.codice, //this.item.value.codice || this.item.value.id,
            descrizione: this.destinazione.descrizione // this.item.value.descrizione
          } */
          this.$emit('change', { model: this.item.model, subModel: this.item.subModel, value, item: this.item.value })
        }
      },
      async onNuovaDestinazione() {
        if (!this.nuovaDestinazione) {
          this.editedItem = { ...this.editedItemDefault, codice: uuidv4() }
        }
        this.nuovaDestinazione = !this.nuovaDestinazione        
      },
      async onModificaDestinazione() {
        if (!this.modificaDestinazione) {
          let dest = this.clifor.recapiti[this.destinazione.id] // .find(x => x.codice === this.destinazione.codice)
          this.editedItem = { ...this.editedItemDefault, ...dest }
          this.editedItem.localitaCompleta = {
            codice: `${dest.cap}-${dest.localita}-${dest.nomeProvincia}`,
            hint: `${dest.nomeProvincia} (${dest.provincia})`
          } 
          this.editedItem.codice = this.editedItem.codice || uuidv4()
        }
        this.modificaDestinazione = !this.modificaDestinazione
      },
      async onSalva() {
        this.saving = true
        const ed = this.editedItem
        let dest = {
          codice: ed.codice,
          tipo: ed.tipo,
          indirizzo: ed.indirizzo,
          localita: ed.localitaCompleta.localita,
          cap: ed.localitaCompleta.cap,
          provincia: ed.localitaCompleta.provincia,
          nomeProvincia: ed.localitaCompleta.nomeProvincia,
          nazione: ed.localitaCompleta.nazione,
          nomeNazione: ed.localitaCompleta.nomeNazione,
          telefono: ed.telefono,
          email: ed.email
        }
        await clienti.salvaDestinazione(this.cliforSelezionato.codice, dest)
        await this.leggeRecapiti()
        this.destinazione = this.items.find(x => x.codice === dest.codice)
        this.saving = false
        if (this.modificaDestinazione) {
          this.modificaDestinazione = false
        }
        if (this.nuovaDestinazione) {
          this.nuovaDestinazione = false
        }
      }
    }
  }
</script>
